import type { RefObject } from 'react'
import React, { createContext, useContext, useState, useEffect } from 'react'
import { createPortal } from 'react-dom'

export const TabsPortalContext = createContext<RefObject<HTMLDivElement> | null>(null)

const TabsPortalProvider = ({ location, children }): JSX.Element => {
  const [tabsPortalRef] = useState(location)

  return <TabsPortalContext.Provider value={tabsPortalRef}>{children}</TabsPortalContext.Provider>
}

export const TabsListPortal = ({ children }): JSX.Element => {
  const tabsPortalRef = useContext(TabsPortalContext)
  const [portalReady, setPortalReady] = useState(false)

  useEffect(() => {
    setPortalReady(true)
  }, [tabsPortalRef])

  return portalReady && tabsPortalRef?.current ? createPortal(children, tabsPortalRef.current) : children
}

export default TabsPortalProvider
